export default __webpack_public_path__ + "static/media/Bhima.b72b8fd8.png";